import { defineComponent } from 'vue';
import EasyIcon from './EasyIcon.vue';

// functional component for svgIcon
export function easyIcon(
  name: string,
  options?: { prefix?: string; fill?: string }
) {
  return defineComponent({
    setup(_props, ctx) {
      return () => (
        <EasyIcon
          {...ctx.attrs}
          name={name}
          prefix={options?.prefix}
          fill={options?.fill}
        />
      );
    }
  });
}

export { EasyIcon };
